import {
  ConfirmationNumber as TicketIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

type SidebarProps = {
  open: boolean;
  width: number;
};

const menuOptions = [
  {
    id: 'home',
    label: 'Home',
    icon: HomeIcon,
    href: '/',
    exact: true,
  },
  {
    id: 'conferences',
    label: 'Conferences',
    icon: TicketIcon,
    href: '/conferences',
    exact: false,
  },
];

export function Sidebar({ open, width }: SidebarProps) {
  const theme = useTheme();
  const router = useRouter();
  return (
    <Drawer
      sx={{
        width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width,
          border: 0,
          boxSizing: 'border-box',
          paddingTop: theme.spacing(8),
          paddingX: theme.spacing(1),
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <List>
        {menuOptions.map((item) => (
          <ListItem key={item.id} sx={{ paddingX: 0, paddingY: '2px' }}>
            <Link href={item.href} passHref>
              <ListItemButton
                selected={
                  item.exact
                    ? router.pathname === item.href
                    : router.pathname.startsWith(item.href)
                }
                sx={{
                  padding: theme.spacing(1),
                  borderRadius: 1,
                  color: theme.palette.primary.main,
                  '&:hover': {
                    background: theme.palette.common.white,
                  },
                  '&.Mui-selected': {
                    background: theme.palette.secondary.main,
                    color: theme.palette.common.white,
                  },
                  '&.Mui-selected .MuiListItemIcon-root': {
                    color: theme.palette.common.white,
                  },
                  '&.Mui-selected:hover': {
                    background: theme.palette.secondary.dark,
                    color: theme.palette.common.white,
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: theme.palette.primary.main,
                    minWidth: 24,
                    marginRight: theme.spacing(1),
                  }}
                  color="inherit"
                >
                  <item.icon />
                </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Drawer>
  );
}
